// Tab List (FilterCategory)
export const TabList1 = [
	{
		id: "ongoing",
		title: "Ongoing applications",
	},
	{
		id: "submitted",
		title: "Submitted applications",
	},
	{
		id: "completed",
		title: "Completed applications",
	},
	{
		id: "savings",
		title: "Savings",
	},
];

export const TabList2 = [
	{
		id: "created_assets",
		title: "Created assets",
	},
	{
		id: "inactive",
		title: "Inactive Assets",
	},
	{
		id: "active",
		title: "Active Assets",
	},
	{
		id: "funded",
		title: "Funded Assets",
	},
	{
		id: "savings",
		title: "Savings",
	},
];

export const TabListCreateAsset = [
	{
		id: "product_info",
		title: "Product Information",
	},
	{
		id: "product_catalog",
		title: "Product Catalog",
	},
	{
		id: "lease_info",
		title: "Lease Information",
	},
	{
		id: "summary",
		title: "Summary",
	},
	// {
	// 	title: "Investment Board",
	// 	id: "investment_board",
	// },
	// {
	// 	title: "Submitted Transaction",
	// 	id: "submitted_transaction",
	// },
];

// Parameters
export const LeaseStructureOptions = ["Lease To Own", "Operating Lease"];
// export const leaseTypeArray = ["Quick Lease", "Sponsored Lease"];

// Table Head Cells
export const OngoingLeaseHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "trnId", title: "TRANSACTION ID", width: 138 },
	{ field: "leaseType", title: "LEASE TYPE", width: 50 },
	{ field: "profile", title: "PROFILE", width: 50 },
	{ field: "product.productName", title: "ASSET", width: 50 },
	{ field: "productCategory", title: "CATEGORY", width: 50 },
	{ field: "price", title: "VALUE", sortable: false, width: 60 },
	{ field: "interest", title: "INTEREST", sortable: false, width: 50 },
	{ field: "request", title: "REQUEST", sortable: false, width: 50 },
	{ field: "approvalStatus", title: "APPROVAL", sortable: false, width: 50 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const RequestLeaseHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "assetObj?.id", title: "ASSET ID", width: 60 },
	{ field: "product.productName", title: "ASSET", width: 50 },
	{ field: "leaseType", title: "LEASE TYPE", width: 50 },
	{ field: "profile", title: "PROFILE", width: 50 },
	{ field: "leasee", title: "LEASEE", width: 50 },
	{ field: "productCategory", title: "CATEGORY", width: 50 },
	{ field: "brand", title: "BRAND", width: 50 },
	{ field: "model", title: "MODEL", width: 50 },
	{ field: "year", title: "YEAR", width: 50 },
	{ field: "condition", title: "CONDITION", width: 50 },
	// { field: "color", title: "COLOR", width: 50 },
	{ field: "request", title: "REQUEST", sortable: false, width: 50 },
	{ field: "approvalStatus", title: "APPROVAL", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const CompletedLeaseHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "trnId", title: "TRANSACTION ID", width: 138 },
	{ field: "leaseType", title: "LEASE TYPE", width: 134 },
	{ field: "product.productName", title: "ASSET", width: 50 },
	{ field: "leasee", title: "LEASEE", width: 50 },
	{ field: "productCategory", title: "CATEGORY", width: 50 },
	{ field: "price", title: "VALUE", sortable: false, width: 60 },
	{ field: "interest", title: "INTEREST", sortable: false, width: 50 },
	{ field: "paymentStatus", title: "PAYMENT STATUS", sortable: false, width: 50 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const CreatedAssetsHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "productName", title: "ASSET", width: 95 },
	{ field: "leaseType", title: "LEASE TYPE", width: 134 },
	{ field: "investor", title: "INVESTOR", width: 50 },
	{ field: "category", title: "CATEGORY", width: 50 },
	{ field: "brand", title: "BRAND", width: 50 },
	{ field: "model", title: "MODEL", width: 50 },
	{ field: "year", title: "YEAR", width: 50 },
	{ field: "condition", title: "CONDITION", width: 50 },
	// { field: "color", title: "COLOR", width: 50 },
	{ field: "amount", title: "AMOUNT", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const SavingsHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "savingsType", title: "SAVINGS TYPE", width: 100 },
	{ field: "productName", title: "ASSET", width: 100 },
	{ field: "frequency", title: "FREQUENCY", width: 50 },
	{ field: "dayOfTheMonth", title: "DAY OF MONTH", width: 100 },
	{ field: "tenure", title: "TENOR", width: 50 },
	{ field: "amountToSave", title: "AMOUNT", width: 60 },
	{ field: "interestRate", title: "INTEREST", width: 50 },
	{ field: "automation", title: "AUTOMATION", width: 50 },
	{ field: "paymentMode", title: "PAYMENT MODE", sortable: false, width: 50 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const InvestorLeaseHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "product", title: "ASSET", width: 50 },
	// { field: "profile", title: "PROFILE", width: 50 },
	{ field: "investor", title: "Investor", width: 50 },
	{ field: "category", title: "CATEGORY", width: 50 },
	{ field: "brand", title: "BRAND", width: 50 },
	{ field: "model", title: "MODEL", width: 50 },
	// { field: "year", title: "YEAR", width: 50 },
	{ field: "condition", title: "CONDITION", width: 50 },
	// { field: "color", title: "COLOR", width: 50 },
	{ field: "request", title: "REQUEST", sortable: false, width: 50 },
	{ field: "status", title: "STATUS", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 50 },
];

export const AssetRegistrationHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "trnId", title: "TRANSACTION ID", width: 138 },
	{ field: "leaseType", title: "LEASE TYPE", width: 134 },
	{ field: "product.productName", title: "ASSET", width: 95 },
	{ field: "productCategory", title: "CATEGORY", width: 50 },
	{ field: "price", title: "VALUE", sortable: false, width: 60 },
	{ field: "interest", title: "INTEREST", sortable: false, width: 50 },
	{ field: "request", title: "REQUEST", sortable: false, width: 50 },
	{ field: "asset_registration", title: "ACTION", sortable: false, width: 50 },
];

export const InsuranceHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 120 },
	{ field: "trnId", title: "TRANSACTION ID", width: 138 },
	{ field: "leaseType", title: "LEASE TYPE", width: 134 },
	{ field: "product.productName", title: "ASSET", width: 95 },
	{ field: "productCategory", title: "CATEGORY", width: 50 },
	{ field: "price", title: "VALUE", sortable: false, width: 60 },
	{ field: "interest", title: "INTEREST", sortable: false, width: 50 },
	{ field: "request", title: "REQUEST", sortable: false, width: 50 },
	{ field: "insurance", title: "ACTION", sortable: false, width: 50 },
];
